/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
UserMark = xClass("UserMark", Event)
var dayTime = 3600000 * 24
var pkTimeOffset = 3600000 * 8
var cycleTime = dayTime * 31
var day_newMark = 7
var cycleTime_newMark = dayTime * day_newMark
var onlineRemarkGoodsId = 48
var offlineRemarkGoodsId = 47
var instance = null
let canShare
var isNewMark = false           //  默认还是老签到
let SnsProxy = require("clover/sns/SnsProxy")
UserMark.MarkEvent = table(
    [1, "Marked", "MARKEVENT.MARKED"],
)

UserMark.prototype.ctor = function () {
    var self = this
    self.bind(self)
}

/**
 * 获取单例类
 */
UserMark.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserMark.new()
    }
    return instance
}

/**
 * 更新签到信息
 * @param showLoading
 * @param successCallback
 * @param failCallback
 * @param cancelCallback
 */
UserMark.prototype.updateMarkInfo = function (showLoading, successCallback, failCallback, cancelCallback) {
    var self = this

    //  根据不同签到版本做不同处理
    if (isNewMark) {
        //  新版签到，直接获取签到信息
        function onSuccess(evt) {
            isNewMark = evt.data.newFlag
            let markInfo = (evt.data || table()).markInfo || table()
            UserManager.getInstance().setMarkRef(markInfo, isNewMark)
            if (successCallback) {
                successCallback()
            }
        }
        function onFail(evt) {
            if (failCallback) {
                failCallback(evt)
            }
        }
        function onCancel() {
            if (cancelCallback) {
                cancelCallback()
            }
        }
        var http = GetMarkVersionHttp.new(showLoading)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load()
    } else {
        //  当前显示为旧版签到，检查是否可以切换到新签到版本
        function onSuccess(evt) {
            isNewMark = evt.data.newFlag
            if (isNewMark) {
                let markInfo = (evt.data || table()).markInfo || table()
                UserManager.getInstance().setMarkRef(markInfo, isNewMark)
                if (successCallback) {
                    successCallback()
                }
            } else {
                function onSuccess_oldMark(evt) {
                    let markInfo = (evt.data || table()).markInfo || table()
                    UserManager.getInstance().setMarkRef(markInfo, isNewMark)
                    canShare = evt.data.canShare
                    if (successCallback) {
                        successCallback()
                    }
                }
                function onFail_oldMark(evt) {
                    if (failCallback) {
                        failCallback(evt)
                    }
                }
                function onCancel_oldMark() {
                    if (cancelCallback) {
                        cancelCallback()
                    }
                }
                var http = GetMarkInfoHttp.new(showLoading)
                http.addEventListener(Events.kComplete, onSuccess_oldMark)
                http.addEventListener(Events.kError, onFail_oldMark)
                http.addEventListener(Events.kCancel, onCancel_oldMark)
                if (META.platform === XcloverPlatform.wechatgame) {
                    http.load(true)
                }else {
                    http.load(false)
                }
            }
        }
        function onFail(evt) {
            if (failCallback) {
                failCallback(evt)
            }
        }
        function onCancel() {
            if (cancelCallback) {
                cancelCallback()
            }
        }
        var http = GetMarkVersionHttp.new(showLoading)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load()
    }
}
UserMark.prototype.canShare = function () {
    let self = this
    return !!__DEBUG || (canShare && META.platform == XcloverPlatform.wechatgame)
}
UserMark.prototype.getMarkInfo = function () {
    var self = this

    if (isNewMark) {
        var [canMark, canRemark, canMarkDay, cycleTime] = self.refresh()
        var mark = UserManager.getInstance().getMarkRef()
        var meta = MetaManager.getInstance().getNewMarkConfig().mark_reward[mark.getMarkNum() + 1]
        return table(
            [1, "canMark", canMark],
            [1, "canRemark", canRemark],
            [1, "canMarkDay", canMarkDay],
            [1, "cycleTime", cycleTime],
            [1, "cycleStartTime", mark.getStartTime()],
            [1, "markList", mark.getMarkList()],
            [1, "remarkNum", mark.getAddNum()],
            [1, "videoTimes", mark.videoTimes],
            [1, "remainDay", Math.floor(cycleTime - (Localhost.time() - mark.getStartTime()) / dayTime)],
            [1, "remarkGoodsId", $len(((meta || table()).rewards || table())) > 1 && onlineRemarkGoodsId || offlineRemarkGoodsId]
        )
    } else  {
        var [canMark, canRemark, canMarkDay, cycleTime] = self.refresh()
        var mark = UserManager.getInstance().getMarkRef()
        var meta = MetaManager.getInstance().getMarkByNum(mark.getMarkNum() + 1)
        return table(
            [1, "canMark", canMark],
            [1, "canRemark", canRemark],
            [1, "canMarkDay", canMarkDay],
            [1, "cycleTime", cycleTime],
            [1, "cycleStartTime", mark.getStartTime()],
            [1, "markNum", mark.getMarkNum()],
            [1, "remarkNum", mark.getAddNum()],
            [1, "randomRewards", mark.randomRewards],
            [1, "remainDay", Math.floor(cycleTime - (Localhost.time() - mark.getStartTime()) / dayTime)],
            [1, "remarkGoodsId", $len(((meta || table()).rewards || table())) > 1 && onlineRemarkGoodsId || offlineRemarkGoodsId]
        )
    }
}
UserMark.prototype.canMark = function () {
    var self = this
    return self.refresh()[0]
}
UserMark.prototype.markedBefore = function () {
    var self = this
    var mark = UserManager.getInstance().getMarkRef()
    return mark.getMarkTime() > 0
}
UserMark.prototype.mark = function (successCallback, failCallback, cancelCallback, data) {
    var self = this

    //  检查是否为新版签到，新签到走新逻辑
    if (isNewMark) {
        self.newMark(successCallback, failCallback, cancelCallback, data)
        return
    }

    function onFail(evt) {
        console.warn("markv2http fail")
        if (failCallback) {
            failCallback(evt)
        }
    }
    function onSuccess(evt) {
        
        console.warn("markv2http success")
        var mark = UserManager.getInstance().getMarkRef()
        var markRef = MarkRef.create().fromLua(evt.data.markInfo)
        if (mark.getMarkNum() === markRef.getMarkNum() && mark.getStartTime() === markRef.getStartTime()) {
            onFail(table([1, "data", ZooErrorCode.MARK_FAILED]))
            return
        }
        var rewards = evt.data.rewardItems || table()
        for (var i = 1, v = rewards[1]; v; i++ , v = rewards[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK)
        }
        UserManager.getInstance().setMarkRef(evt.data.markInfo)
        UserManager.getInstance().flushUserData()
        evt.data.rewards = clone(rewards)
        if (successCallback) {
            successCallback(evt)
        }
        DCAssist.dc4AutoMarkOnDay(markRef.getMarkNum(), "old")
        self.dispatchEvent(table([1, "name", UserMark.MarkEvent.Marked], [1, "num", self.canMark()]))
    }
    function onCancel() {
        console.warn("markv2http cancel")
        if (cancelCallback) {
            cancelCallback()
        }
    }
    if (!self.canMark()) {
        onFail(table([1, "data", -3]))
        return
    }
    console.warn("begin markv2http")
    var http = MarkV2Http.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)

    if(data && !data.adMark) {
        http.load({
            chest: true
        })
    } else {
        http.load(data)
    }
}
/**
 * 新版签到
 */
UserMark.prototype.newMark = function (successCallback, failCallback, cancelCallback, data) {
    var self = this
    function onFail(evt) {
        console.warn("markv3http fail")
        if (failCallback) {
            failCallback(evt)
        }
    }
    function onSuccess(evt) {
        
        console.warn("markv3http success")
        var mark = UserManager.getInstance().getMarkRef()
        var markRef = MarkRef.create().fromLua(evt.data.markInfo, true)
        if (mark.getMarkNum() === markRef.getMarkNum() && mark.getStartTime() === markRef.getStartTime() && self.lastMarkRewars == evt.data.rewards) {
            onFail(table([1, "data", ZooErrorCode.MARK_FAILED]))
            return
        }
        var rewards = evt.data.rewards || table()
        self.lastMarkRewars = rewards
        var sevenDayRewars = evt.data.sevenDaysRewards || table()

        let dc_data = {};
        if (data && data.videoFlag){
            dc_data = {
                category: "ad",
                sub_category: "mark"
            }
        }
        for (var i = 1, v = rewards[1]; v; i++ , v = rewards[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK,dc_data)
        }
        for (var i = 1, v = sevenDayRewars[1]; v; i++ , v = sevenDayRewars[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK,dc_data)
        }
        UserManager.getInstance().setMarkRef(evt.data.markInfo, true)
        UserManager.getInstance().flushUserData()
        evt.data.rewards = clone(rewards)
        evt.data.sevenDaysRewards = sevenDayRewars
        if (successCallback) {
            successCallback(evt)
        }
        DCAssist.dc4AutoMarkOnDay(markRef.getMarkNum(), "new", rewards)
        self.dispatchEvent(table([1, "name", UserMark.MarkEvent.Marked], [1, "num", self.canMark()]))
    }
    function onCancel() {
        console.warn("markv2http cancel")
        if (cancelCallback) {
            cancelCallback()
        }
    }
    if (!self.canMark()) {
        onFail(table([1, "data", -3]))
        return
    }
    console.warn("begin markv3http")
    var http = MarkV3Http.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)

    if (data) {
        http.load(data)
    } else {
        http.load({
            videoFlag: false,
            adFlag: false,
            cashFlag: false,
            videoAndMarkFlag: false
        })
    }
}
UserMark.prototype.canRemark = function () {
    var self = this
    var [_, canRemark] = self.refresh()
    return canRemark
}
UserMark.prototype.remark = function (successCallback, failCallback, cancelCallback) {
    var self = this

    function onSuccess(evt) {
        var mark = UserManager.getInstance().getMarkRef()
        var markNum = mark.getMarkNum()
        mark.setMarkNum(mark.getMarkNum() + 1)
        mark.setAddNum(mark.getAddNum() + 1)
        var config = MetaManager.getInstance().getMarkConfig()
        var rewards = ((config[mark.getMarkNum()] || table()).rewards || table())
        for (var i = 1, v = rewards[1]; v; i++ , v = rewards[i]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK)
        }
        UserManager.getInstance().flushUserData()
        evt.data = evt.data || table()
        evt.data.rewards = clone(rewards)
        if (successCallback) {
            successCallback(evt)
        }
        DCAssist.dc4MarkAppendMark(markNum, "old")
    }
    function onFail(evt) {
        if (failCallback) {
            failCallback(evt)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback()
        }
    }
    if (!self.canRemark()) {
        onFail(table([1, "data", 0]))
        return
    }
    var mark = UserManager.getInstance().getMarkRef()
    var meta = MetaManager.getInstance().getMarkByNum(mark.getMarkNum() + 1)
    if ($len((meta.rewards || table())) > 1) {
        UserDeal.getInstance().buyGoods(onlineRemarkGoodsId, 1, UserDealPayType.kCash, null, null, onSuccess, onFail, onCancel, ModuleName.MARK)
    } else {
        UserDeal.getInstance().buyGoods(offlineRemarkGoodsId, 1, UserDealPayType.kCash, null, null, onSuccess, onFail, onCancel, ModuleName.MARK)
    }
}

/**
 * 新版补签
 */
UserMark.prototype.newRemark = function (successCallback, failCallback, cancelCallback, target, isVideoRemark) {
    var self = this

    function onSuccess(evt) {
        if (!isVideoRemark) {
            //  扣除风车币
            var markRef = UserManager.getInstance().getMarkRef()
            var getMarkConfig = MetaManager.getInstance().getNewMarkConfig()
            var addNum = markRef.getAddNum()
            var dcData = table()
            dcData.coin1 = UserManager.getInstance().getUserRef().getCash() || 0
            dcData.coin2 = dcData.coin1 - getMarkConfig.remark_cost[addNum] || 0
            dcData.currency = ItemWorth.HAPPY_COINS || ""
            dcData.currency_num = getMarkConfig.remark_cost[addNum] || 0
            dcData.cost = getMarkConfig.remark_cost[addNum] || 0
            dcData.revenueCost = getMarkConfig.remark_cost[addNum] || 0
            dcData.trade_id = `${UserManager.getInstance().uid}_267_${Localhost.timeInSec()}` 
            UserCash.getInstance().consumeCash(getMarkConfig.remark_cost[addNum])
            //  由于风车币补签没有走传统的购买物品的逻辑，因此需要额外做71打点，267代表新版补签，没有实际购买该道具，只是方便打点做区分
            DCAssist.dc4UseCurrency(267, 1, ModuleName.MARK, dcData)
            //  风车币补签打点
            DCAssist.dc4MarkAppendMark(UserManager.getInstance().getMarkRef().getMarkNum(), "new")
        } else {
            //  看广告补签打点
            DCAssist.dc4MarkAdAppendMark(UserManager.getInstance().getMarkRef().getMarkNum())
        }
        //  更新签到信息
        UserManager.getInstance().setMarkRef(evt.data.markInfo, true)
        //  加奖励
        var rewards = evt.data.rewards || table()
        self.lastMarkRewars = rewards
        var sevenDayRewars = evt.data.sevenDaysRewards || table()

        let dc_data = {}
        if (isVideoRemark){
            dc_data = {
                category: "ad",
                sub_category: "mark"
            }
        }

        for (var i = 1, v = rewards[1]; v; i++ , v = rewards[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK, dc_data)
        }
        for (var i = 1, v = sevenDayRewars[1]; v; i++ , v = sevenDayRewars[i]) {
            v.itemId = tonumber(v.itemId)
            v.num = tonumber(v.num)
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.MARK, dc_data)
        }
        //  刷新用户信息
        UserManager.getInstance().flushUserData()
        evt.target = target
        if (successCallback) {
            successCallback(evt)
        }
    }
    function onFail(evt) {
        if (failCallback) {
            failCallback(evt)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback()
        }
    }
    if (!self.canRemark()) {
        onFail(table([1, "data", ZooErrorCode.Mark_CANT_REMARK]))
        return
    }

    var http = MarkV3Http.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    // TODO: 测试代码
    // http.load({
    //     videoFlag: false,
    //     adFlag: false,
    //     cashFlag: true,
    //     markDay: target
    // })
    // return
    if (isVideoRemark) {
        DCAssist.dc4AdClick("mark", "mark_supplement_ad_click", { "ad_src": "mark_panel" });
        //  看广告补签
        var snsProxy = SnsProxy.getInstance()
        if (snsProxy.allowAd()) {
            snsProxy.prepareAd("Remark")
            .then(()=>{
                snsProxy.showAd("Remark")
                .then(isEnd=> {
                    if (isEnd) {
                        DCAssist.dc4AdFinish("mark", "mark_supplement_ad_finish", { "ad_src": "mark_panel" });
                        http.load({
                            videoFlag: false,
                            adFlag: true,
                            cashFlag: false,
                            markDay: target
                        })
                    } else {
                        DCAssist.dc4AdDropOut("mark", "mark_supplement_ad_dropout", { "ad_src": "mark_panel" });
                        Toast.make(getText("error.tip.dropout_ad"));
                        if (cancelCallback) {
                            cancelCallback()
                        }
                    }
                },(err)=>{
                    if (err && err.errMsg){
                        Toast.make(err.errMsg)
                    }else{
                        Toast.make(getText("video.ad.error"));
                    }
                    DCAssist.dc4AdNoMore("mark", "mark_supplement_noAds", { "ad_src": "mark_panel" });
                    if (failCallback) {
                        failCallback(err)
                    }
                    DCAssist.dc4AdNoMore("mark", "mark_supplement_noAds", { "ad_src": "mark_panel" });
                    if (failCallback) {
                        failCallback(err)
                    }
                })
                .catch(err=> {
                    Toast.make(getText("video.ad.error"), null, function () {
                        if (failCallback) {
                            failCallback(err)
                        }
                    });
                    DCAssist.dc4AdNoMore("mark", "mark_supplement_noAds", { "ad_src": "mark_panel" });
                    if (window.logCenter) {
                        let msg = {
                            message: "Mark onRewardedVideoAdError: " + JSON.stringify(err)
                        }
                        window.logCenter.log(msg)
                    } else {
                        cc.error("Mark onRewardedVideoAdError: " + err.errMsg)
                    }
                })
            })
            .catch(err=> {
                Toast.make(getText("video.ad.error"), null, function () {
                    if (cancelCallback) {
                        cancelCallback()
                    }
                });
            })
        } else {
            Toast.make(getText("video.ad.error"), null, function () {
                if (cancelCallback) {
                    cancelCallback()
                }
            });
        }
    } else {
        http.load({
            videoFlag: false,
            adFlag: false,
            cashFlag: true,
            markDay: target
        })
    }
}
UserMark.prototype.refresh = function () {
    var self = this

    var mark = UserManager.getInstance().getMarkRef()
    isNewMark = mark.isNewMark
    //  新版签到
    if (isNewMark) {
        var getMarkConfig = MetaManager.getInstance().getNewMarkConfig()
        var curTime = Localhost.time()
        var [cycleStartTime, markNum, addNum, markTime] = [mark.getStartTime(), mark.getMarkNum(), mark.getAddNum(), mark.getMarkTime()]
        var markDay = markTime - (markTime + pkTimeOffset) % dayTime
        var startMarkDay = cycleStartTime - (cycleStartTime + pkTimeOffset) % dayTime
        if (markTime === 0) {
            //  新玩家
            startMarkDay = curTime
            ;[markNum, addNum] = [0, 0]
        } else if (markNum >= day_newMark && (markDay + dayTime <= curTime)) { 
            // 完成签到且跨天
            while (curTime - cycleStartTime > cycleTime_newMark) {
                cycleStartTime = cycleStartTime + cycleTime_newMark
            }
            ;[markNum, addNum] = [0, 0]
            for (var i = 1; i <= $len(mark.markList); i++) {
                mark.markList[i] = 0
            }
        } else if (startMarkDay + cycleTime_newMark <= curTime) { 
            // 未完成签到跨周期
            while (curTime - startMarkDay > cycleTime_newMark) {
                startMarkDay = startMarkDay + cycleTime_newMark
            }
            markNum = 0
            addNum = 0
            for (var i = 1; i <= $len(mark.markList); i++) {
                mark.markList[i] = 0
            }
        }
        mark.setStartTime(startMarkDay)
        mark.setMarkNum(markNum)
        mark.setAddNum(addNum)
        var canMarkDay = false
        var canRemark = false
        for (var i = 1; i <= $len(mark.markList); i++) {
            if (mark.markList[i] === 0) {
                canRemark = true
                break
            }
        }
        return [curTime > markDay + dayTime, canRemark, canMarkDay, cycleTime_newMark]
    } else {
        //  旧版签到
        var markMeta = MetaManager.getInstance().getMarkConfig()
        var curTime = Localhost.time()
        var [cycleStartTime, markNum, addNum, markTime] = [mark.getStartTime(), mark.getMarkNum(), mark.getAddNum(), mark.getMarkTime()]
        var markDay = Math.floor((markTime - cycleStartTime) / dayTime) * dayTime + cycleStartTime
        if (markNum >= $len(markMeta) && markDay + dayTime < curTime) { // 完成签到且跨天
            cycleStartTime = markDay + dayTime
                ;[markNum, addNum] = [0, 0]
        } else if (curTime - cycleTime > cycleStartTime) { // 未完成签到跨周期，切换到新签到
            cycleStartTime = curTime
                ;[markNum, addNum] = [0, 0]
        }
        if (cycleStartTime + cycleTime < curTime) {
            while (cycleStartTime + dayTime < curTime) {
                cycleStartTime = cycleStartTime + dayTime
            }
        }
        mark.setStartTime(cycleStartTime)
        mark.setMarkNum(markNum)
        mark.setAddNum(addNum)
        var price = MetaManager.getInstance().global.fillSign[mark.getAddNum() + 1] || 10
        var meta = MetaManager.getInstance().getGoodsMeta(onlineRemarkGoodsId)
        if (meta) {
            meta.qCash = price
        }
        var meta = MetaManager.getInstance().getGoodsMeta(offlineRemarkGoodsId)
        if (meta) {
            meta.qCash = price
        }
        var canMarkDay = Math.min(Math.ceil((curTime - cycleStartTime) / dayTime), $len(markMeta))
        return [curTime > markDay + dayTime, curTime <= (markDay + dayTime) && canMarkDay > markNum, canMarkDay, cycleTime]
    }
}
/**
 * 获取当前签到版本是否为新版
 */
UserMark.prototype.isNewMark = function () {
    var self = this

    return isNewMark
}
/**
 * 获取新版签到今日签到完毕后的连签天数（主要用于展示当前看广告后给与的连签奖励）
 */
UserMark.prototype.getDayPreContinuous = function () {
    var self = this;

    var markRef = UserManager.getInstance().getMarkRef()
    var markList = clone(markRef.markList)
    var now = Localhost.time()
    now = now - (now + pkTimeOffset) % dayTime
    var startTime = markRef.startTime - (markRef.startTime + pkTimeOffset) % dayTime
    markList[Math.ceil((now - startTime) / dayTime) + 1] = 1
    
    //  检查签到信息和UI
    if (markList) {
        //  计算当前签到周期最大连签天数
        let max = 0;
        let now = 0;
        for (var i = 1; i <= markList.length; i++) {
            if (markList[i] === 1) {
                now = now + 1;
            } else {
                max = now > max ? now : max;
                now = 0
            }
        }
        max = now > max ? now : max;
        return max
    }
    return 0
}